<template>
  <div class="holder-total flex-page">
    <main class="pagina-de-erro container">
      <div>
        <img src="../assets/imgs/icone_atencao.svg" alt="Atenção!" class="icone-atencao" />
      </div>

      <div class="area-descritiva">
        <h1>Parece que você não está conectado.</h1>
        <p>
          Não conseguimos autenticar sua conexão.
          <br />Tente efetuar login no sistema novamente, clicando no botão abaixo:
        </p>
        <a class="botao-padrao" @click="clickHandle">Ir para o login</a>
      </div>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'LoginComponent',
  data() {
    return {
      URL: `${window.location.protocol}//${window.location.host}/_sys/portal-login/`,
    };
  },
  computed: {
    ...mapGetters('apiRoute', {
      redirect: 'route',
    }),
  },
  methods: {
    clickHandle() {
      const redirect = this.redirect ? `?redirect=${this.redirect}` : '';
      window.location.href = this.URL + redirect;
    },
  },
  beforeMount() {
    const re = /\W*(revista\W.*)\W*/g;
    Object.keys(window.localStorage).map(k => {
      if (!k.match(re)) {
        window.localStorage.removeItem(k);
      }
    });

    this.clickHandle();
  },
};
</script>

<style lang="scss" scoped>
@import '../estilo/sass/_formulas.scss';

.holder-total {
  background-color: #f3f3f3;
}

.flex-page {
  @extend %flex;
  @extend %justify-start;
  @extend %align-items-center;
  height: 100vh;
  padding: 0px;
}
.container {
  @extend %area-de-utilizacao;
}

.pagina-de-erro {
  margin: 0 auto;
  @extend %flex;
  @extend %direction-row;
  flex: 1;
}
.icone-atencao {
  margin-right: 50px;
}
.pagina-de-erro h1 {
  font-family: 'OpenSans';
  font-weight: 100;
  font-size: 40px;
  line-height: 40px;
  color: #777;
  margin: 0px;
}
.pagina-de-erro p {
  font-family: 'OpenSans';
  font-size: 18px;
  color: #777;
  margin: 0px;
  margin-top: 30px;
}
.pagina-de-erro .area-descritiva {
  @extend %flex;
  @extend %direction-column;
  @extend %justify-start;
  @extend %align-items-start;
  margin-top: 15px;
}
.pagina-de-erro .area-descritiva .botao-padrao {
  font-size: 18px;
  margin-top: 80px !important;
}

.botao-padrao {
  font-family: 'VivoType';
  background-color: #660099;
  text-decoration: none;
  color: white;
  padding: 20px 50px;
  border-radius: 10px;
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0.03em;
}
.botao-padrao:hover {
  -webkit-box-shadow: 0px 10px 30px 1px #6600994d;
  -moz-box-shadow: 0px 10px 30px 1px #6600994d;
  box-shadow: 0px 10px 30px 1px #6600994d;
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .pagina-de-erro {
    flex-direction: column !important;
    max-width: 80vw !important;
  }
}
</style>
